<template>
  <ErrorModal />
  <div class="email-templates-edit-page column q-ml-xl q-my-md">
    <div class="row justify-between">
      <h2 class="title">Edit email templates</h2>
      <q-btn
        class="orange-btn-filled q-mb-lg q-mt-lg bold-font q-mr-xl"
        label="Update consultant emails"
        no-caps
        style="width: auto;"
        @click="updateShowConsultantEmailsPopup(true)"
      />
    </div>
    <div class="column">
      <span>Select language: </span>
      <div class="q-gutter-xl q-mb-xl">
        <q-radio v-model="language" label="Dutch" val="nl" />
        <q-radio v-model="language" label="German" val="de" />
      </div>
    </div>
    <div class="column">
      <span>Select template category: </span>
      <div class="q-gutter-sm">
        <q-radio
          v-for="(category, index) in emailTemplateCategories"
          :key="index"
          v-model="emailTemplateCategory"
          :val="category"
          :label="category"
          :disable="language == ''"
          @click="getEmailTemplateOptions(emailTemplateCategory, language)"
        />
      </div>
      <div class="column q-my-xl">
        <span>E-mails: </span>
        <q-select
          label="Select template"
          transition-show="jump-up"
          transition-hide="jump-up"
          filled
          v-model="emailTemplateSelected"
          :options="emailTemplateOptions"
          style="width: 250px"
          :disable="emailTemplateCategory == ''"
          @update:model-value="getTemplateByType"
        />
      </div>
    </div>
    <div class="column">
      <span>Subject:</span>
      <froala
        class="froala-editor"
        id="sample3"
        v-model:value="templateSubject"
      ></froala>
    </div>
    <div class="column q-my-xl">
      <span>Body:</span>
      <froala
        class="froala-editor"
        id="sample3"
        v-model:value="templateBody"
      ></froala>
    </div>
    <q-btn
      class="orange-btn-filled q-mb-lg q-mt-lg bold-font q-mr-xl"
      label="Submit changes"
      no-caps
      style="width: auto; align-self: end;"
      @click="updateEmailTemplate()"
    />
  </div>
  <q-dialog v-model="successfullyUpdated" persistent>
    <q-card style="width: 300px">
      <q-card-section class="row items-center">
        <span>Template has been updated!</span>
      </q-card-section>
      <q-card-actions align="right" class="bg-white text-teal">
        <q-btn flat label="OK" @click="disableDialog()" />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-dialog v-model="showConsultantEmailsPopup" persistent>
    <q-card style="width: 600px">
      <q-card-section class="column">
        <span>Update consultant emails</span>
        <q-input
          outlined
          dense
          v-model="consultantEmailDutch"
          label="Dutch consultant email"
          lazy-rules
          :rules="[isValidEmail, requiredFieldRule]"
          class="q-mt-md"
        />
        <q-input
          outlined
          dense
          v-model="consultantEmailGerman"
          label="German consultant email"
          lazy-rules
          class="q-mt-md"
          :rules="[isValidEmail, requiredFieldRule]"
        />
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          flat
          label="Submit"
          @click="updateConsultantsEmails()"
          class="orange-btn-filled"
          no-caps
        />
        <q-btn
          flat
          class="orange-btn"
          label="Cancel"
          @click="updateShowConsultantEmailsPopup(false)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
import { ref, onMounted, computed, watch } from "vue";
import store from "../store/index";
import EmailTemplateService from "../services/email.templates.service";
import ErrorModal from "./ErrorModal.vue";
export default {
  name: "EditEmailTemplates",
  components: {
    ErrorModal
  },
  setup() {
    onMounted(async () => {
      await EmailTemplateService.getConsultantEmails();
      EmailTemplateService.getEmailTemplateCategories();
    });
    const successfullyUpdated = computed({
      get: () => store.state.emailTemplate.showSuccessfullyUpdatedDialog
    });
    const emailTemplateCategory = ref("");
    const language = ref("");
    const emailTemplateSelected = computed({
      get: () => store.state.emailTemplate.emailTemplateSelected,
      set: val => store.commit("emailTemplate/updateSelectedTemplateType", val)
    });
    const emailTemplateOptions = computed({
      get: () => store.state.emailTemplate.emailTemplateOptions
    });
    const templateBody = computed({
      get: () => store.state.emailTemplate.selectedTemplateBody,
      set: body => store.commit("emailTemplate/updateTemplateBody", body)
    });

    const templateSubject = computed({
      get: () => store.state.emailTemplate.selectedTemplateSubject,
      set: subject =>
        store.commit("emailTemplate/updateTemplateSubject", subject)
    });
    const getEmailTemplateOptions = (emailTemplateCategory, languageCode) => {
      EmailTemplateService.getEmailTemplatesByCategory(
        emailTemplateCategory,
        languageCode
      );
    };
    const getTemplateByType = () => {
      if (emailTemplateSelected.value != "") {
        EmailTemplateService.getEmailTemplateByType(
          emailTemplateSelected,
          language
        );
      }
    };
    const selectedTemplateId = computed({
      get: () => store.state.emailTemplate.selectedTemplateId
    });

    const updateTemplate = {
      id: selectedTemplateId,
      subject: templateSubject,
      body: templateBody,
      languageCode: language
    };
    const updateEmailTemplate = async () => {
      await EmailTemplateService.updateEmailTemplate(updateTemplate);
    };
    const disableDialog = () => {
      store.commit("emailTemplate/disableSuccessfullyUpdatedDialog");
    };
    const emailTemplateCategories = computed({
      get: () => store.state.emailTemplate.emailTemplateCategories
    });

    let prevLanguage = ref("");
    watch(
      [emailTemplateCategory, language],
      ([newLanguage], [oldEmailTemplateCategory, oldLanguage]) => {
        if (oldEmailTemplateCategory !== "" && newLanguage !== oldLanguage) {
          emailTemplateCategory.value = "";
        }
        store.commit("emailTemplate/resetState");
        prevLanguage.value = oldLanguage;
      }
    );

    const updateShowConsultantEmailsPopup = val => {
      store.commit("emailTemplate/updateShowConsultantEmailsPopup", val);
    };

    const showConsultantEmailsPopup = computed({
      get: () => store.state.emailTemplate.showConsultantEmailsPopup
    });
    const consultantEmailDutch = computed({
      get: () => store.state.emailTemplate.consultantEmailDutch,
      set: val => store.commit("emailTemplate/updateConsultantEmailDutch", val)
    });
    const consultantEmailGerman = computed({
      get: () => store.state.emailTemplate.consultantEmailGerman,
      set: val => store.commit("emailTemplate/updateConsultantEmailGerman", val)
    });

    const updateConsultantsEmails = () => {
      EmailTemplateService.updateConsultantEmails({
        consultantEmailDutch: consultantEmailDutch.value,
        consultantEmailGerman: consultantEmailGerman.value
      });
      updateShowConsultantEmailsPopup(false);
    };
    return {
      consultantEmailDutch,
      consultantEmailGerman,
      updateConsultantsEmails,
      updateShowConsultantEmailsPopup,
      showConsultantEmailsPopup,
      language,
      emailTemplateCategories,
      successfullyUpdated,
      disableDialog,
      updateTemplate,
      selectedTemplateId,
      emailTemplateSelected,
      emailTemplateOptions,
      templateBody,
      templateSubject,
      emailTemplateCategory,
      getEmailTemplateOptions,
      getTemplateByType,
      updateEmailTemplate,
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || "Invalid email";
      },
      requiredFieldRule: [
        val => (val && val.length > 0) || "Field is required!"
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
    store.commit("emailTemplate/resetState");
    next();
  }
};
</script>
